/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable react/jsx-no-comment-textnodes */
import React from 'react';
import './styles.css';
import { useSelector } from 'react-redux';
// Importando componente
import Card from '~/components/Card';
import { Container } from './styles';

export default function ChatNew() {
  const user = useSelector(state => state.user.profile);
  return (
    <Container>
      <Card>
        <div id="overflow">
          <iframe
            src={user.time.instance_number}
            frameBorder="0"
            id="sib_overflow"
            width="100%"
            height="600px"
            marginHeight="50px"
          />
        </div>
      </Card>
    </Container>
  );
}
